<section class="w-full mx-auto bg-gray-50 pt-15 dark:bg-gray-900 dark:text-white">
    <!-- Title -->
    <div class="font-bold flex justify-center text-3xl sm:text-4xl md:text-[40px] text-dark mb-4">Why Choose XL Highway Travel?</div>

    <div class="w-full h-full flex flex-col items-center md:py-4 py-10">
        <!-- Col - 1 -->
        <div
            class="xl:w-[80%] sm:w-[85%] w-[90%] mx-auto flex md:flex-row flex-col lg:gap-4 gap-2 justify-center lg:items-stretch md:items-center mt-4">
            <img class="md:w-[50%] w-full md:rounded-t-lg rounded-sm"
                src="/assets/images/sections/Targeted-Marketing-and-Outreach.jpg?v=1" alt="marketing-outreach" />

            <div class="md:w-[50%] w-full bg-gray-100 dark:bg-gray-900 dark:text-gray-400 md:p-4 p-0 rounded-md">
                <h2 class="text-3xl font-semibold text-gray-900 dark:text-white">Targeted Marketing and Outreach</h2>
                <p class="text-md mt-4">Tailored Packages: We focus on developing travel packages specifically for INGO
                    and Donor community members. These would include options for flights, accommodation, and in-country
                    transportation tailored to the unique needs of these professionals, including proximity to project
                    sites and secure locations. Being part of a very large travel consortium in South African, we have
                    negotiating power with a lot of the airlines and suppliers.</p>
            </div>
        </div>
        <!-- Col - 2 -->
        <div
            class="xl:w-[80%] sm:w-[85%] w-[90%] mx-auto flex md:flex-row flex-col-reverse lg:gap-4 gap-2 justify-center lg:items-stretch md:items-center mt-6">
            <div class="md:w-[50%] w-full bg-gray-100 dark:bg-gray-900 dark:text-gray-400 md:p-4 p-0 rounded-md">
                <h2 class="text-3xl font-semibold text-gray-900 dark:text-white">Competitive Pricing and Flexibility
                </h2>
                <p class="text-md mt-4">Having established personal relationships with our airline representatives, we
                    will always endeavor to negotiate the best possible rates for the non-profit sector. We are offered
                    discounted rates for group bookings and understand the need to be flexible with the
                    often-unpredictable nature of humanitarian work.</p>
            </div>
            <!--  -->
            <img class="md:w-[50%] w-full md:rounded-t-lg rounded-sm"
                src="/assets/images/sections/Competitive-Pricing-and-Flexibility.jpg?v=1" alt="pricing" />
        </div>
        <!-- Col - 3 -->
        <div
            class="xl:w-[80%] sm:w-[85%] w-[90%] mx-auto flex md:flex-row flex-col lg:gap-4 gap-2 justify-center lg:items-stretch md:items-center mt-4">
            <img class="md:w-[50%] w-full md:rounded-t-lg rounded-sm"
                src="/assets/images/sections/Building-Long-Term-Relationships.jpg?v=1" alt="marketing-outreach" />

            <div class="md:w-[50%] w-full bg-gray-100 dark:bg-gray-900 dark:text-gray-400 md:p-4 p-0 rounded-md">
                <h2 class="text-3xl font-semibold text-gray-900 dark:text-white">Personalized and Accessible Service
                </h2>
                <p class="text-md mt-4">Dedicated Account Managers: We assign dedicated agents to INGO clients who will
                    be available to manage bookings, handle emergencies, and provide personalized advice on travel
                    arrangements. For the last 15 years Trace Patchin has been successfully handling the Operation
                    Mobilisation(OM) account which is confirmed in the testimonial below.<br><br>

                    On-the-Ground Support: We have partnerships with local guides and transport services in key regions
                    to offer on-the-ground support, ensuring a smooth and safe experience for travellers.<br><br>

                    Emergency Assistance: Our dedicated consultants can make themselves available after hours
                    specifically for emergencies that may arise during our INGO Client travels.</p>
            </div>
        </div>
        <!-- Col - 4 -->
        <div
            class="xl:w-[80%] sm:w-[85%] w-[90%] mx-auto flex md:flex-row flex-col-reverse lg:gap-4 gap-2 justify-center lg:items-stretch md:items-center mt-6">
            <div class="md:w-[50%] w-full bg-gray-100 dark:bg-gray-900 dark:text-gray-400 md:p-4 p-0 rounded-md">
                <h2 class="text-3xl font-semibold text-gray-900 dark:text-white">Leveraging Technology</h2>
                <p class="text-md mt-4">Online Booking Portal: Should you wish, we can offer a secure, easy-to-use
                    online portal where INGO staff can book flights and accommodations directly, view itineraries, and
                    make changes as needed.
                    Mobile App: We also offer a mobile app for real-time updates on flight status, accommodation
                    details, and emergency contacts, ensuring that travellers are always informed and connected.</p>
            </div>
            <img class="md:w-[50%] w-full md:rounded-t-lg rounded-sm"
                src="/assets/images/sections/Leveraging-Technology.jpg?v=1" alt="Technology" />
        </div>
        <!-- Col - 5 -->
        <div
            class="xl:w-[80%] sm:w-[85%] w-[90%] mx-auto flex md:flex-row flex-col lg:gap-4 gap-2 justify-center lg:items-stretch md:items-center mt-4">
            <!--  -->
            <img class="md:w-[50%] w-full md:rounded-t-lg rounded-sm"
                src="/assets/images/sections/Dedicated-Account-Manager.jpg?v=1" alt="accounts" />

            <div class="md:w-[50%] w-full bg-gray-100 dark:bg-gray-900 dark:text-gray-400 md:p-4 p-0 rounded-md">
                <h2 class="text-3xl font-semibold text-gray-900 dark:text-white">Building Long-Term Relationships</h2>
                <p class="text-md mt-4">Loyalty Programs: Our suppliers offer a variety of loyalty programmes
                    specifically our clients, offering rewards like free upgrades, discounts on future bookings, or
                    complimentary services such as airport transfers.<br><br>

                    Feedback and Improvement: We continually stay in touch with, and collect feedback from, INGO clients
                    to continuously improve our services and meet their evolving needs.</p>
            </div>
        </div>
        <!-- Col - 6 -->
        <div
            class="xl:w-[80%] sm:w-[85%] w-[90%] mx-auto flex md:flex-row flex-col-reverse lg:gap-4 gap-2 justify-center lg:items-stretch md:items-center mt-6">
            <div class="md:w-[50%] w-full bg-gray-100 dark:bg-gray-900 dark:text-gray-400 md:p-4 p-0 rounded-md">
                <h2 class="text-3xl font-semibold text-gray-900 dark:text-white">Branding and Reputation Building</h2>
                <p class="text-md mt-4">Our African Expertise: Being based in South Africa, and having agents around the
                    country, we offer a deep knowledge of African destinations, including safety considerations,
                    cultural insights, and logistics management, making us the go-to travel agency for organizations
                    operating on the continent.</p>
            </div>
            <img class="md:w-[50%] w-full md:rounded-t-lg rounded-sm"
                src="/assets/images/sections/Branding-and-Reputation-Building.jpg?v=1" alt="branding" />
        </div>
    </div>
</section>